import CircularLoading from "@/components/base/circular-loading";

export const LoadingModule = () => (
  <div className="hero min-h-screen">
    <div className="hero-content flex items-center justify-center">
      <CircularLoading className="animate-spin" />
    </div>
  </div>
);
